export default __webpack_public_path__ + "static/media/akimovv.ca7a1e3d.jpg";